import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { GatePassService } from '../gate-pass.service'
import { SelectablesService } from '../selectables.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { OnAccountService } from '../_services/_masters/on-account.service';
import { PartyService } from '../_services/_masters/party.service';
import { VehicleService } from '../_services/_masters/vehicle.service';
import { DestinationService } from '../_services/_masters/destination.service';

import { ConsignorService } from '../_services/_masters/consignor.service';
import { ProductService } from '../_services/_masters/product.service';
import { RRFormService } from '../r-r-form.service';
import { NgxSpinnerService } from 'ngx-spinner';


import 'rxjs/add/operator/map';
import swal from 'sweetalert2';

// import * as $ from 'jquery';
declare var $ : any;

const now = new Date();
const user_info = JSON.parse(localStorage.getItem('currentUser'));
const headers = new Headers({'Content-Type': 'application/json','Authorization': JSON.parse(localStorage.getItem("user_token"))});
const options = new RequestOptions({ headers: headers });

class GatePass {
  gp_date:string;
  gp_number:string;
  station: string;
  consignor: string;
  loading: string;
  gatePassNumber: string;
  on_account: string;
  party:string;
  truck_number: string;
  owned_by: string;
  product: string;
  weight:string;
  qty_bags:string;
  rr_number : string;
  rr_date: string;
  sto_number : string;
  destination :  string;
  godown :  string;
}
 
@Component({
	selector: 'app-gate-pass',
	templateUrl: './gate-pass.component.html',
	styleUrls: ['./gate-pass.component.css']
})
export class GatePassComponent implements OnInit 
{
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;
	gatePassForm : FormGroup;

	check_branch: boolean = true;
	selected_branch_name="";

	stations : string[] = [];
	products : string[] = [];
	consignors: any[] = [];
	godowns: any[] = [];
	onaccount: string[] = [];
	party: string[] = [];
	truckno:string[]=[];
	destination:string[]=[];
	rr_number:any[]=[];


	advance_info_flag : boolean = false;
	gp_saved : boolean = false;
	last_gp_number="";
	product_package=[];
	get_product_package:any;
	bsConfig: Partial<BsDatepickerConfig>;
	// dtOptions: DataTables.Settings = {};
	dtOptions: any = {};
	bsValue : Date = new Date();

	gatepass: GatePass[] = [];
	modalGPForm :FormGroup;
	modalData:any;
	// We use this trigger because fetching the list of persons can be quite long,
	// thus we ensure the data is fetched before rendering
	dtTrigger: Subject<any> = new Subject();
	message:any;
	selected_rr_num:any;
	model:any;
	loadPoint:any;
	selected_branch:string;
	selected_client:string;

	selected_godown_to :boolean = false;

	response :any = null;

	private url = environment.url;
	gp_date:Date=new Date(Date.now());

	rr_balance_weight : any = null ;
	rr_dispatched_weight : any = null ;



	constructor(
		private gatePassService : GatePassService, 
		private http: Http, 
		private selectablesService : SelectablesService,
		private router : Router,
		private selectConsignerService : ConsignorService,
		private selectProductService : ProductService,
		private selectBranchService : SelectablesService,
		private onAccountService : OnAccountService,
		private partyService : PartyService,
		private VehicleService:VehicleService,
		private DestinationService:DestinationService,
		public RRFormService:RRFormService,
		private spinner: NgxSpinnerService
		) { }

	ngOnInit() {

		

		this.selected_godown_to = this.selectablesService.by_godown; 
		this.selected_rr_num = this.selectablesService.selected_rr_number;
		this.loadPoint = this.getSelectedLoadingPoint()
		this.selected_branch = this.selectablesService.selected_branch;
		this.selected_client = this.selectablesService.selected_client;
		if(this.selected_client && this.selected_branch)
		{
			this.selected_branch_name=this.selected_branch;
			this.getLastGPNumber(this.selected_client);
			this.getDestinationBySelectedBranchAndClient(this.selected_client);
		}

		this.gatePassForm = new FormGroup({
			'rr_number': new FormControl(this.selected_rr_num),
			'sto_number': new FormControl(null),
			'gp_date': new FormControl(this.bsValue, Validators.required),
			'station': new FormControl(this.selected_branch, Validators.required),
			'consignor' : new FormControl(this.selected_client, Validators.required),
			'loading' : new FormControl(this.getSelectedLoadingPoint(), Validators.required),
			'on_account': new FormControl(null, Validators.required),
			'party' : new FormControl(null, Validators.required),
			'destination': new FormControl(null, Validators.required),
			'truck_number':new FormControl(null, Validators.required),
			'owned_by': new FormControl(null, Validators.required),
			'product' : new FormControl(null, Validators.required),
			'weight': new FormControl(null, Validators.required),
			'qty_bags' : new FormControl(null, Validators.required),
			'godown' : new FormControl(null)
			
			// gp_number:string,
			// gatePassNumber: string,
		});
		this.modalGPForm = new FormGroup({
			'rr_number':new FormControl(null, Validators.required),
			'gp_number':new FormControl(null, Validators.required),
			'gp_date': new FormControl(null, Validators.required),
			'rr_date': new FormControl(null, Validators.required),
			'station': new FormControl(null, Validators.required),
			'consignor' : new FormControl(null, Validators.required),
			'loading' : new FormControl(null, Validators.required),
			'product' : new FormControl(null, Validators.required),
			'sto_number':  new FormControl(null),
			'on_account': new FormControl(null, Validators.required),
			'party' : new FormControl(null, Validators.required),
			'destination' : new FormControl(null, Validators.required),
			'truck_number':new FormControl(null, Validators.required),
			'owned_by': new FormControl(null, Validators.required),
			'weight': new FormControl(null, Validators.required),
			'qty_bags' : new FormControl(null, Validators.required),
			'godown' : new FormControl(null, Validators.required)
		});

		var form_info = localStorage.getItem('form_info');
		var form_data = JSON.parse(form_info);
		if (form_info)
		{

				this.gatePassForm.patchValue({
				'rr_number': form_data.rr_number,
				'station': form_data.station,
				'consignor' : form_data.consignor,
				'loading' : form_data.loading,
				// 'product' : form_data.product,
			});
			//this.getRRTableByRRNumber(form_data.rr_number);
			//this.getProductPacking(form_data.product);
			$("#smallProduct").text(form_data.product);
		}


		this.bsConfig = Object.assign({}, { containerClass: 'theme-default' });

		this.dtOptions = {
				pagingType: 'full_numbers',
				pageLength: 5,
				responsive: true,
				ordering : false,
				// order : [[1, "Desc"]],
				rowCallback: (row: Node, data: any[] | Object, index: number) => {
					const self = this;
					// Unbind first in order to avoid any duplicate handler
					// (see https://github.com/l-lin/angular-datatables/issues/87)
					$('td', row).unbind('click');
					$('td', row).bind('click', () => {
						self.someClickHandler(data);
					});
					return row;
				},
				dom: 'Bfrtip',
				// Configure the buttons
				buttons: [
					// 'columnsToggle',
					'colvis',
					'copy',
					'print',
					'excel'
				]
			};

		this.http.get(this.url + '/gatepass/all', options)
			.map(this.extractData)
			.subscribe(forms => {
				this.gatepass = forms;
				console.log(this.gatepass);
				// Calling the DT trigger to manually render the table
				this.dtTrigger.next();
		});


		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getRRNumber();
				this.getBranch();
				this.getConsignorAndTruckBySelectedBranch(null);
				//this.getDestinationBySelectedBranch(null);
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{
				this.gatePassForm.get('station').setValue(temp['branch']);
  				this.stations.push(temp['branch']);
				this.getConsignorAndTruckBySelectedBranch(temp['branch']);
				this.getRRFormWithBranch(temp['branch']);
				this.check_branch = true;
				//this.getDestinationBySelectedBranch(temp['branch']);
			}
		}

		this.getOnAccount();
		this.getParty();	
		this.loadAllAutoComplete();	
		this.getBalanceRRWeight(this.gatePassForm.get('rr_number').value);
	}
	getRRNumber()
    {
    	this.rr_number=[];
    	this.RRFormService.getAllRRForm()
		.subscribe(
			rr_number => {
				for(var i=0;i<rr_number.length;i++)
				{
					this.rr_number.push(rr_number[i]['rr_number']);
				}
			});
    }
    getRRFormWithBranch(branch)
    {
    	this.rr_number=[];
    	this.RRFormService.getRRFormWithBranch(branch)
		.subscribe(
			rr_number => {
				for(var i=0;i<rr_number.length;i++)
				{
					this.rr_number.push(rr_number[i]['rr_number']);
				}
			});
    }
	getDestination()
    {
    	this.destination=[];
		this.DestinationService.getAllDestination()
		.subscribe(
			destination => {
				console.log(destination);
				for(var i=0;i<destination.length;i++)
				{
					this.destination.push(destination[i]['destination_name']);
				}
			});
    }
	
	getOnAccount()
    {
     	this.onAccountService.getAllOnAccount()
		.subscribe(
			onaccount => {
				for(var i=0;i<onaccount.length;i++)
				{
					this.onaccount.push(onaccount[i]['account_name']);
				}
			});
    }
    getParty()
    {
     	this.partyService.getAllParty()
		.subscribe(
			party => {
				for(var i=0;i<party.length;i++)
				{
					this.party.push(party[i]['party_name']);
				}
			});
    }
	getConsignor()
    {
     	this.selectConsignerService.getAllConsignor()
		.subscribe(
			consignors => {
				for(var i=0;i<consignors.length;i++)
				{
					if (this.consignors.includes(consignors[i]['consignor_name'])){

					}
					else{
						this.consignors.push(consignors[i]['consignor_name']);
					}
				}
			});
    }
    getDestinationBySelectedBranchAndClient(client)
    {

    	let destination_table_name=this.selected_branch_name+"_"+client+"_destination";
    	this.destination=[];
    	this.DestinationService.getDestinationFormWithClientAndBranch(destination_table_name)
		.subscribe(
			destination => {
				for(var i=0;i<destination.length;i++)
				{
					if (this.destination.includes(destination[i]['destination_name'])){

					}
					else{
						this.destination.push(destination[i]['destination_name']);
					}
				}
			});
    }
    getProductAndDestinationByBranchAndClient(client)
    {
    	if(client)
    	{
    		this.getLastGPNumber(client);
    		this.getProductBySelectedClient(client);
    		this.getGPTableBySelectedBranchAndClient(client)
			this.getDestinationBySelectedBranchAndClient(client);
			this.getGodownBySelectedClient(client);
    	}
    }
    getGPTableByRRNumber(get_rr_number)
    {
    	if(get_rr_number)
    	{	
    		console.log("GP Table update")
    		this.getBalanceRRWeight(get_rr_number);
    		this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				dtInstance.destroy();
				this.http.get(this.url + '/gatepass/get/byrrnumber/'+get_rr_number, options)
					.map(this.extractData)
					.subscribe(forms => {
					this.gatepass = forms;
					// Calling the DT trigger to manually render the table
					this.dtTrigger.next();
				});
			});
			console.log("GP Table update")
    	}
    	
    }

    getGPTableBySelectedBranchAndClient(client)
	{
		this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
			dtInstance.destroy();
			this.http.get(this.url + '/gatepass/get/branchandclient/'+this.selected_branch_name+'/'+client, options)
				.map(this.extractData)
				.subscribe(forms => {
				this.gatepass = forms;
				// Calling the DT trigger to manually render the table
				this.dtTrigger.next();
			});
		});

	}
    getLastGPNumber(client)
    {
    	this.last_gp_number="";
    	this.gatePassService.getLastGPNumber(client)
		.subscribe(
			lastgpnumber => {
				this.last_gp_number = lastgpnumber.toString();
			});
    }
    getConsignorAndTruckBySelectedBranch(branch)
    {
    	this.truckno=[];
    	this.getConsignorBySelectedBranch(branch);
    	this.VehicleService.getVehicleFormWithBranch(branch)
		.subscribe(
			truckno => {
				for(var i=0;i<truckno.length;i++)
				{
					this.truckno.push(truckno[i]['truck_no']);
				}
			});
    	
    }
    getConsignorBySelectedBranch(branch)
    {
    	console.log(user_info["branch"])
		if (branch == null){
			branch=user_info["branch"];
			console.log(user_info["branch"])
		}
		else{
			this.selected_branch_name=branch;
		}
    	// this.selected_branch_name=branch;
    	this.consignors=[];
     	this.selectConsignerService.getConsignorFormWithBranch(branch)
		.subscribe(
			consignors => {
				//alert(consignors);
				
				for(var i=0;i<consignors.length;i++)
				{
					if (this.consignors.includes(consignors[i]['consignor_name'])){

					}
					else{
						this.consignors.push(consignors[i]['consignor_name']);
					}
				}
			});
    }
    getProductBySelectedClient(client)
    {
    	this.products=[];
    	this.selectProductService.getProductByClientName(client)
		.subscribe(
			products => {
				for(var i=0;i<products.length;i++)
				{
					this.products.push(products[i]['product_name']);
					this.product_package.push(products[i]);
				}
			});
    }
    getGodownBySelectedClient(client)
    {
    	this.godowns=[];
    	this.http.get(this.url + "/masters/godown/get/branchandclient/" +this.gatePassForm.get("station").value + "/" + client, options)
		.subscribe(
			godowns => {
				var godown = godowns.json()
				console.log(godown);
				for(var i=0;i<godown.length;i++)
				{
					if (this.godowns.includes(godown[i]['godown_name'])){

					}
					else{
						this.godowns.push(godown[i]['godown_name']);
					}
				}
			});
    }
    getBranch()
	{
		// this.selectBranchService.getBranches()
		this.http.get(this.url+"/branch/all", options)
		.subscribe(
			branch => {
				console.log(branch.json());
				var branches = branch.json();
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
	}
    getProductQty(product_weight)
    {
    	let get_product_qty = product_weight.target.value*1000/this.get_product_package;
    	if (!isNaN(get_product_qty))
    	{
    		this.gatePassForm.get('qty_bags').setValue(get_product_qty);
    		this.modalGPForm.get('qty_bags').setValue(get_product_qty);
    	}
    	else
    	{
    		this.gatePassForm.get('qty_bags').setValue("");
    		this.modalGPForm.get('qty_bags').setValue("");
    	}
    }
    getProductWeight(product_qty)
    {
    	let get_product_weight = product_qty.target.value*this.get_product_package/1000;
    	if (!isNaN(get_product_weight))
    	{
    		this.gatePassForm.get('weight').setValue(get_product_weight);
    		this.modalGPForm.get('weight').setValue(get_product_weight);
    	}
    	else
    	{
    		this.gatePassForm.get('weight').setValue("");
    		this.modalGPForm.get('weight').setValue("");
    	}
    }
    getProductPacking(product_name)
    {
    	if(product_name)
    	{
    		this.get_product_package = this.product_package.find( x => x.product_name == product_name).packing;
    	}
    	    	
    }
	someClickHandler(info: any): void {
		this.gatePassService.getGPFormWith(info[0])
		.subscribe(response => {
			console.log('aaaaa'+JSON.stringify(response))
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			// console.log(this.modalData[0].basic_info.product);
			var date = new Date("2018-08-16");
			var converted_gp_date = date.toISOString();
			console.log(converted_gp_date);
			console.log(this.modalData);

			this.modalGPForm.patchValue({
				"consignor": this.modalData[0].consignor,
				"loading": this.modalData[0].loading,
				"station": this.modalData[0].station,
				'product': this.modalData[0].product,
				"sto_number": this.modalData[0].sto_number,
				"gp_date": this.modalData[0].gp_date,
				// "gp_date": "2018-08-16T00:00:00.000Z",
				"gp_number": this.modalData[0].gp_number,
				'on_account': this.modalData[0].on_account,
				'party' : this.modalData[0].party,
				'destination' : this.modalData[0].destination,
				'truck_number': this.modalData[0].truck_number,
				'owned_by': this.modalData[0].owned_by,
				'weight': this.modalData[0].weight,
				'qty_bags' : this.modalData[0].qty_bags,
				'rr_number': this.modalData[0].rr_number,
				'rr_date': this.modalData[0].rr_date,
				'godown': this.modalData[0].godown

			});
		});	
		$("#default-modal").modal('show');
		this.getConsignorBySelectedBranch(this.modalGPForm.get('station').value)
		this.getProductAndDestinationByBranchAndClient(this.modalGPForm.get('consignor').value)
	};
	onSubmit(){
		console.log(this.gatePassForm);
	}
	advanceInfoFunc(){
		this.advance_info_flag = true
	}
	// Set validator as per selecting loading
	changeLoading(loadBy)
	{	
		console.log(loadBy);
		var form_info = localStorage.getItem('form_info');
		var form_data = JSON.parse(form_info);	
		if (loadBy === 'By Rail')
		{	
			this.gatePassForm.get('rr_number').setValidators([Validators.required]);
			if(form_data){
				this.gatePassForm.get('rr_number').setValue(form_data.rr_number);
			}
			else{
				this.gatePassForm.get('rr_number').setValue(null);
			}          
			
			this.gatePassForm.get('sto_number').setValue(null);
			this.gatePassForm.get('sto_number').setValidators(null);
			this.gatePassForm.get('godown').setValue(null);
			this.gatePassForm.get('godown').setValidators(null);
			this.gatePassForm.get('rr_number').updateValueAndValidity();
			this.gatePassForm.get('sto_number').updateValueAndValidity();
			this.gatePassForm.get('godown').updateValueAndValidity();
			this.getGodownBySelectedClient(this.gatePassForm.get('consignor').value);
		} 
		else if(loadBy === 'By Godown')  
		{
			// this.gatePassForm.get('sto_number').setValidators([Validators.required]);  
			this.gatePassForm.get('godown').setValue(null);          
			this.gatePassForm.get('godown').setValidators([Validators.required]);            
			this.gatePassForm.get('rr_number').setValue(null);
			this.gatePassForm.get('rr_number').setValidators(null);
			// this.gatePassForm.get('sto_number').updateValueAndValidity();
			this.gatePassForm.get('godown').updateValueAndValidity();
			this.gatePassForm.get('rr_number').updateValueAndValidity();
			this.getGodownBySelectedClient(this.gatePassForm.get('consignor').value);
		}
		console.log(this.gatePassForm); 
		console.log(this.gatePassForm.valid); 
	}
	gPSave(){ 
		this.spinner.show()
		this.gp_saved = true; 
		console.log(this.gatePassForm); 
		console.log(this.gatePassForm.valid); 
		this.gatePassService.addNewGatePass(JSON.stringify(this.gatePassForm.value))
		.subscribe(response => {
			console.log(response);
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
					dtInstance.destroy();
					this.http.get(this.url + '/gatepass/all', options)
						.map(this.extractData)
						.subscribe(forms => {
						this.gatepass = forms;
						console.log(this.gatepass[0].gp_number);
						// Calling the DT trigger to manually render the table
						this.dtTrigger.next();
					});
				});
				this.getBalanceRRWeight(this.gatePassForm.get("rr_number").value);
				this.spinner.hide();
				window.open(this.url + "/gatepass/test/print/" + ( response['gp_number']  ), "_blank");
			}
		});
		console.log(this.gatePassForm.value);
	}

	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};

	selectToday() {
		return	this.model = {year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()};
	};

	getSelectedLoadingPoint(){
		var point = this.selectablesService.selected_loading_point;
		console.log("getSeletecLoading-GP: " + point);
		if (point == 'rail' || point == 'By Rail'){
			return "By Rail";
		}
		else if(point == 'godown' || point == 'By Godown') {
			return "By Godown";
		}

		else{
			return "By Rail"
		}
	};

	createLR(){
		this.selectablesService.getSelectedLoadPoint(this.modalData[0].loading);
		this.selectablesService.getRRNumber(this.modalData[0].rr_number);
		this.selectablesService.getSelectedBranch(this.modalData[0].station);
		this.selectablesService.setConsigner(this.modalData[0].consignor);
		// this.selectablesService.getAdvanceInfo(this.modalData[0].advance_info);
		console.log(this.modalGPForm.get('godown').value);
		localStorage.setItem('form_info', JSON.stringify({
			'rr_number': this.modalGPForm.get('rr_number').value,
			'gp_number':this.modalGPForm.get('gp_number').value,
			'gp_date': this.modalGPForm.get('gp_date').value,
			'rr_date': this.modalGPForm.get('rr_date').value,
			'station': this.modalGPForm.get('station').value,
			'consignor' : this.modalGPForm.get('consignor').value,
			'loading' : this.modalGPForm.get('loading').value,
			'product' : this.modalGPForm.get('product').value,
			'sto_number':  this.modalGPForm.get('sto_number').value,
			'on_account': this.modalGPForm.get('on_account').value,
			'party' : this.modalGPForm.get('party').value,
			'destination' : this.modalGPForm.get('destination').value,
			'truck_number': this.modalGPForm.get('truck_number').value,
			'owned_by': this.modalGPForm.get('owned_by').value,
			'weight': this.modalGPForm.get('weight').value,
			'qty_bags' : this.modalGPForm.get('qty_bags').value,
			'godown' : this.modalGPForm.get('godown').value
		}));
		$("#default-modal").modal('toggle');
		this.router.navigate(['lrform'])

	};

	updateGP(){
		console.log(this.modalGPForm.value);
		this.http.post( this.url + "/gatepass/update", this.modalGPForm.value, options)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response);
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'Gate pass Updated Successfully'){
					swal(
						' Success',
						'Gate pass Form Updated Successfully',
						'success'
					);
					this.getBalanceRRWeight(this.modalGPForm.get("rr_number").value);
				}

				if (this.response.message === 'Gate pass Information not Changed'){
					swal(
						' Info ',
						'Gate pass information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					' Acknowledge Failed',
					'Please enter a Gate pass number',
					'error'
				);
			}
			
		});
	};

	printModalGP(){
		window.open(this.url + "/gatepass/test/print/" +  this.modalGPForm.get('gp_number').value , "_blank");
	};


	reset(){
		this.gatePassForm.reset();
	};

	deleteGP(){
		console.log(this.modalGPForm.value);
		this.http.post( this.url + "/gatepass/check/delete", this.modalGPForm.value, options)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			if (this.response["status"]) {
				swal({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!'
				}).then((result) => {
					if (result.value) {
						this.http.post( this.url + "/gatepass/delete", {"gp_number" :this.modalGPForm.get('gp_number').value}, options)
						.subscribe(res => {
							console.log(res.json());
							var feedback = res.json();
							if (feedback.status){
								$("#default-modal").modal('hide');
								swal(
									'Deleted!',
									'Your Gate-pass has been deleted.',
									'success'
								);
								this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
									dtInstance.destroy();
									this.http.get(this.url + '/gatepass/all', options)
										.map(this.extractData)
										.subscribe(forms => {
										this.gatepass = forms;
										console.log(this.gatepass);
										// Calling the DT trigger to manually render the table
										this.dtTrigger.next();
									});
								})
							}
						});
					}
				})
			}
			else{
				if (this.response.message = "GP is Present in LR"){
					swal(
						'Failed!',
						'This GP number is used for LR receipts.',
						'error'
					)
				}
			}

		});
	};
	loadAllAutoComplete(){
		console.log("Load All Function")
		this.getConsignorAndTruckBySelectedBranch(this.gatePassForm.get('station').value);
		this.getProductAndDestinationByBranchAndClient(this.gatePassForm.get('consignor').value);
		this.changeLoading(this.gatePassForm.get("loading").value);

	}

	getBalanceRRWeight(rr_number){
		if((this.gatePassForm.get("loading").value == "By Rail") && (this.gatePassForm.get("rr_number").value != null )){
			this.http.get(this.url + '/rrform/get/' + rr_number, options)
			.subscribe( res =>{
				this.response = res.json();
				console.log(this.response);
				this.rr_balance_weight = Number(this.response[0]["gp_rr_weight"]).toFixed(2);
				this.rr_dispatched_weight = (Number(this.response[0]["rr_weight"]) - this.rr_balance_weight).toFixed(2);
				console.log(this.rr_balance_weight);
				console.log(this.rr_dispatched_weight);
			});
		}
		else{
			this.rr_balance_weight = 0;
			this.rr_dispatched_weight = 0;
			console.log(this.rr_balance_weight);
			console.log(this.rr_dispatched_weight);
		}
	};
}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/gate-pass/gate-pass.component.ts